module.exports = __webpack_public_path__ + "static/media/image_59.e686834d.png";